export const isDebug = process.env.is_debug;
export const credentials = !process.env.is_debug;
export const loginUrl = process.env.login_url;
export const logoutUrl = process.env.logout_url;
export const fastdfsUrl = process.env.fastdfs_url;
export const tdgUrl = process.env.TDG_URL;
export const tdgApiKey = process.env.TDG_API_KEY;
export const shipmentStatusURL = process.env.SHIPMENT_STATUS_URL;
export const shipmentStatusApiKey = process.env.SHIPMENT_STATUS_API_KEY;
export const firebaseConfig = process.env.firebase_config;
export const page = 1;
export const pageSize = 20;
export const pageSizes = [20, 50, 100, 200, 500];
export const login_jiuyescm_ticket = process.env.login_jiuyescm_ticket;
export const ticket = { login_jiuyescm_ticket: login_jiuyescm_ticket };
export const project_env = 'tms_' + process.env.NODE_ENV + '_'
export const pickerOptions = {
	shortcuts: [
		{
			text: "最近一天",
			onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() + 3600 * 1000 * 24 * 1);
				picker.$emit("pick", [end, start]);
			},
		},
		{
			text: "最近两天",
			onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() + 3600 * 1000 * 24 * 2);
				picker.$emit("pick", [end, start]);
			},
		},
		{
			text: "最近三天",
			onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() + 3600 * 1000 * 24 * 3);
				picker.$emit("pick", [end, start]);
			},
		},
	],
};



// WEBPACK FOOTER //
// ./src/config/config.js